<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<!-- START ~~ LOADING STATE, ONLY LOADER VISIBLE -->
@if (isLoading) {
  <div role="status" aria-live="polite" aria-busy="true">
    <span class="profile:sr-only">{{ translations.loadingStatus }}</span>
    <pidx-skeleton-loader></pidx-skeleton-loader>
  </div>
} @else {
  <!-- START ~~ DISPLAY MODE -->
  @if (!editMode) {
    <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
      <div class="profile:min-w-1/4">
        <profile-pds-p-text p-text size="small" color="contrast-medium">
          {{ translations.list.preferredLanguageLabel }}
        </profile-pds-p-text>
      </div>
      <div>
        <profile-pds-p-text
          p-text
          size="inherit"
          class="profile:mt-fluid-md profile:md:mt-0 profile:text-[20px]"
          [attr.lang]="currentLanguageHtmlLang"
          >{{ currentPreferredLanguageTitle }}
        </profile-pds-p-text>
        @if (!isRestricted) {
          <profile-pds-p-button-pure
            p-button-pure
            id="preferred-language-edit-btn"
            class="profile:mt-fluid-sm"
            icon="edit"
            [aria]="{ 'aria-label': translations.list.editButtonA11y }"
            (click)="enterEditMode()"
            >{{ translations.list.editButtonLabel }}
          </profile-pds-p-button-pure>
        }
      </div>
    </div>
  }
  <!-- END ~~ DISPLAY MODE -->
  <!-- START ~~ EDIT MODE -->
  @if (editMode) {
    <div class="profile:mt-fluid-md profile:flex profile:flex-col profile:md:flex-row">
      <div class="profile:w-full profile:md:w-auto profile:md:flex-1 profile:min-w-0">
        <div>
          <profile-pds-p-text p-text id="preferredLanguageInstruction" size="small">{{
            translations.editor.preferredLanguageInstruction
          }}</profile-pds-p-text>
          <form class="profile:mt-fluid-md" [formGroup]="languageDropdownFormGroup">
            <profile-pds-p-select
              p-select
              id="preferred-language-select"
              [formControlName]="'languageDropdown'"
              [filter]="false"
              [label]="translations.list.preferredLanguageLabel"
              aria-describedby="preferredLanguageInstruction"
            >
              @for (option of dropdownItems; track option) {
                <profile-pds-p-select-option p-select-option [value]="option.value" [attr.lang]="toBcp47(option.value)">
                  {{ option.title }}
                </profile-pds-p-select-option>
              }
            </profile-pds-p-select>
          </form>
          <div
            class="profile:flex profile:flex-col profile:gap-y-fluid-sm profile:sm:gap-x-static-sm profile:sm:flex-row profile:mt-fluid-md"
          >
            <profile-pds-p-button
              p-button
              variant="primary"
              (click)="savePreferredLanguage()"
              icon="check"
              [aria]="{ 'aria-label': translations.editor.saveButtonA11y }"
            >
              {{ translations.editor.saveButtonLabel }}
            </profile-pds-p-button>
            <profile-pds-p-button
              p-button
              variant="secondary"
              (click)="leaveEditMode()"
              icon="close"
              [aria]="{ 'aria-label': translations.editor.cancelButtonA11y }"
            >
              {{ translations.editor.cancelButtonLabel }}
            </profile-pds-p-button>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- END ~~ EDIT MODE -->
  <!-- START ~~ OVERLAY LOADER, CONTENT VISIBLE AS WELL AS LOADER OVERLAY -->
  @if (isRefreshing) {
    <pidx-loader [mode]="PidxLoaderModeEnum.OVERLAY" [text]="translations.savingOverlay"></pidx-loader>
  }
  <!-- END ~~ OVERLAY LOADER -->
}
<!-- END ~~ LOADING STATE -->
